import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/daily-compound-interest-calculator',
  component: () => import('../../routes/CompoundDailyInterest.svelte'),
  card: {
    id: 'daily-compound-interest-calculator',
    title: 'Daily Compound Interest Calculator',
    description: 'Calculate compound interest with daily compounding. See how daily deposits accelerate growth and compare APY vs nominal rate.',
    icon: 'trending_up',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/daily-compound-interest-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Compound Daily Interest Calculator – Daily Compounding & APY',
    description: 'Free compound daily interest calculator. Calculate compound interest with daily (365x/year) compounding, effective APY, and daily deposit growth projections.',
  },
};

export default meta;
